import { render } from "./KitOrders.vue?vue&type=template&id=1a90c79e&scoped=true"
import script from "./KitOrders.vue?vue&type=script&lang=js"
export * from "./KitOrders.vue?vue&type=script&lang=js"

import "./KitOrders.vue?vue&type=style&index=0&id=1a90c79e&scoped=true&lang=css"

import exportComponent from "/home/jk/htdocs/vue/mlcc/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a90c79e"]])

export default __exports__